// extracted by mini-css-extract-plugin
module.exports =  {"darkFont":"darkFont_g3GcDfNL","disabled":"disabled_NwsDbaW_"};